// extracted by mini-css-extract-plugin
export default {"container-btn-file":"DownloadButton_container-btn-file__15EM3"};